import employeeCostMutations from './employee-costs'

const mutations = {
  ...employeeCostMutations
}

export default mutations